
import DriverLayout from '../layouts/driver/Layout';
import PublicLayout from '../layouts/public/Layout';

import PasswordPage from '../pages/driver/account/PasswordPage';
import ProfilePage from '../pages/driver/account/ProfilePage';
import LoginPage from '../pages/driver/access/LoginPage';
// import SignupPage from '../pages/member/SignupPage';
import DashboardPage from '../pages/driver/dashboard/DashboardPage';

export default function routes() {

    return [
        {
            path: '/driver',
            element: <PublicLayout />,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: 'login', element: <LoginPage /> },
            ],
        },
        {
            path: '/driver',
            element: <DriverLayout />,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: '', element: <DashboardPage /> },

                { path: 'dashboard', element: <DashboardPage /> },
                { path: 'profile', element: <ProfilePage /> },
                { path: 'password', element: <PasswordPage /> },

                // { path: 'products', element: <ProductsPage /> },
                // { path: 'product/view/:id', element: <ProductViewPage /> },

            ],
        }
    ]
}